// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"349e206b","693":"2c7c3624","845":"4042236e"}[chunkId] + ".chunk.js";
};